<!-- Badge Variant -->
<div *ngIf="variant === 'badge' && audienceSize" class="sp-audience-size-badge" [ngClass]="badgeConfig?.badgeClass">
  {{ formatNumber(audienceSize) }} people
  <span (click)="getAudienceScoreInformation()" class="material-symbols-outlined badge-info-icon">info</span>
</div>

<!-- Indicator Variant -->
<div *ngIf="variant === 'indicator'" class="row d-flex no-gutters sp-audience-score-container">
  <div class="sp-audience-fb-score" [ngClass]="scoreConfig.get(audienceScoreIndicator)?.containerClass">

    <!-- Size very low or very high -->
    <div class="sp-audience-fb-score-ladder">
      <span *ngIf="audienceScoreIndicator === 'size_too_low'" style="font-size: 18px">🥶</span>
      <span *ngIf="audienceScoreIndicator === 'size_too_high'" style="font-size: 18px">🥵</span>
      <span *ngIf="audienceScoreIndicator !== 'size_too_low' && audienceScoreIndicator !== 'size_too_high'" class="sp-audience-fb-score-dot" [ngClass]="scoreConfig.get(audienceScoreIndicator)?.dotClass"></span>
    </div>

    <!-- Size low or high -->
    <div class="sp-audience-fb-score-ladder">
      <span *ngIf="audienceScoreIndicator === 'size_low'" style="font-size: 18px">😨</span>
      <span *ngIf="audienceScoreIndicator == 'size_high'" style="font-size: 18px">😥</span>
      <span *ngIf="audienceScoreIndicator !== 'size_low' && audienceScoreIndicator !== 'size_high'" class="sp-audience-fb-score-dot" [ngClass]="scoreConfig.get(audienceScoreIndicator)?.dotClass"></span>
    </div>

    <!-- Size good -->
    <div class="sp-audience-fb-score-ladder">
      <span *ngIf="audienceScoreIndicator === 'size_good'" style="font-size: 18px">🙂</span>
      <span *ngIf="audienceScoreIndicator !== 'size_good'" class="sp-audience-fb-score-dot" [ngClass]="scoreConfig.get(audienceScoreIndicator)?.dotClass"></span>
    </div>

    <!-- Size perfect -->
    <div class="sp-audience-fb-score-ladder">
      <span *ngIf="audienceScoreIndicator === 'size_perfect'" style="font-size: 18px">😎</span>
      <span *ngIf="audienceScoreIndicator !== 'size_perfect'" class="sp-audience-fb-score-dot" [ngClass]="scoreConfig.get(audienceScoreIndicator)?.dotClass"></span>
    </div>
  </div>
  <div style="display: flex; align-items: center">
    <span>{{ scoreConfig.get(audienceScoreIndicator)?.msg ?? 'No size information' }}</span>
  </div>
  <div style="display: flex;align-items: center;cursor: pointer">
    <span (click)="getAudienceScoreInformation()" class="material-symbols-outlined" style="color: #EF8251">info</span>
  </div>
</div>
